// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseDetails_wrapper__WPVXy"};